import React from "react";
import '../../styles/common/toggle.scss';

interface IToggleProps {
  isToggledOn: boolean;
  label?: string;
  onToggle_toggled: () => void;
  stopPropagation? : boolean; //useful for preventing menu from closing when toggle is placed inside.
  disabled? : boolean;
}

export default function Toggle({
  isToggledOn,
  label,
  onToggle_toggled,
  disabled,
}: IToggleProps) {
  const onOffClassName = isToggledOn ? "on" : "";
  const disabledClassName = disabled ? "disabled" : "";

  return (
    <div
      className={`toggle ${disabledClassName}`}
      onClick={ () => {
        !disabled && onToggle_toggled();
      }}
    >
      <div className="label">{label}</div>
      <div className={`switch ${onOffClassName}`}>
        <div className="knob"/>
      </div>
    </div>
  );
}
